var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 7.33325L9.9825 12.1549C10.2838 12.3559 10.6378 12.4632 11 12.4632C11.3622 12.4632 11.7162 12.3559 12.0175 12.1549L19.25 7.33325M4.58333 17.4166H17.4167C17.9029 17.4166 18.3692 17.2234 18.713 16.8796C19.0568 16.5358 19.25 16.0695 19.25 15.5833V6.41659C19.25 5.93036 19.0568 5.46404 18.713 5.12022C18.3692 4.77641 17.9029 4.58325 17.4167 4.58325H4.58333C4.0971 4.58325 3.63079 4.77641 3.28697 5.12022C2.94315 5.46404 2.75 5.93036 2.75 6.41659V15.5833C2.75 16.0695 2.94315 16.5358 3.28697 16.8796C3.63079 17.2234 4.0971 17.4166 4.58333 17.4166Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.0fcd5711d32d5ad5b7c02e9a2ffa81b4.svg";
export { ForwardRef as ReactComponent };